// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M6.83 12L9.73 14.9Q10.03 15.2 10.02 15.6T9.71 16.3Q9.41 16.58 9.01 16.59T8.31 16.3L3.71 11.7Q3.41 11.4 3.41 11T3.71 10.3L8.31 5.7Q8.59 5.42 9 5.42T9.7 5.7Q10 6 10 6.41T9.7 7.12L6.83 10H16Q18.08 10 19.54 11.46T21 15V18Q21 18.42 20.71 18.71T20 19 19.29 18.71 19 18V15Q19 13.75 18.12 12.88T16 12Z"/>';

/** Reply (communication). */
const icon: IconData = {
  id: "reply",
  name: "Reply",
  category: "communication",
  styles: {
    rounded: { svg: m0 },
    sharp: {
      svg: '<path d="M19 19V15Q19 13.75 18.12 12.88T16 12H6.83L10.43 15.6 9 17 3 11 9 5 10.43 6.4 6.83 10H16Q18.08 10 19.54 11.46T21 15V19Z"/>',
    },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M6.83 12L9.73 14.9Q10.03 15.2 10.02 15.6T9.71 16.3Q9.41 16.58 9.01 16.59T8.31 16.3L3.71 11.7Q3.41 11.4 3.41 11T3.71 10.3L8.31 5.7Q8.59 5.42 9 5.42T9.7 5.7Q10 6 10 6.41T9.7 7.12L6.83 10H16Q18.08 10 19.54 11.46T21 15V18Q21 18.42 20.71 18.71T20 19 19.29 18.71 19 18V15Q19 13.75 18.12 12.88T16 12Z"/></g><path d="M6.83 12L9.73 14.9Q10.03 15.2 10.02 15.6T9.71 16.3Q9.41 16.58 9.01 16.59T8.31 16.3L3.71 11.7Q3.41 11.4 3.41 11T3.71 10.3L8.31 5.7Q8.59 5.42 9 5.42T9.7 5.7Q10 6 10 6.41T9.7 7.12L6.83 10H16Q18.08 10 19.54 11.46T21 15V18Q21 18.42 20.71 18.71T20 19 19.29 18.71 19 18V15Q19 13.75 18.12 12.88T16 12Z"/>',
    },
  },
  animation: () => import("../animations/reply.js"),
};

export default icon;
